import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class Overflow extends React.Component{

    state = {
        overflowVisible: false
    }

    toggleVisibility = (e) => {
        e.stopPropagation();
        const overflowVisible = !this.state.overflowVisible;
        this.setState({ overflowVisible });
    };

    handleClickOutside = (e) => {
        this.setState({ overflowVisible: false });
    };

    renderOverflow = () => {
        return (
            <aside>
                <div className="arrow">
                        <img alt="" src="images/triangle.svg"/>
                    </div>
                <div className="overflow-content">
                    { 
                        this.props.options.map(option => {
                            return <a key={option.label} onClick={e => option.action(this.props.argument)}>{option.icon ? <i className="material-icons">{option.icon}</i> : null}{option.label}</a>
                        })
                    }
                </div>
            </aside>
        );
    };

    render() {
        return (
            <div className="overflow" tabIndex="0" onBlur={this.handleClickOutside}>
                <a onClick={e => this.toggleVisibility(e)}><i className="material-icons">more_vert</i></a>
                <CSSTransitionGroup component="aside" className="overflowAnimation" transitionName="overflowAnimation" transitionEnterTimeout={500} transitionLeaveTimeout={500} >
                    { this.state.overflowVisible && this.props.options ? this.renderOverflow() : null}
                </CSSTransitionGroup>
            </div>
        );
    }
}

Overflow.propTypes = {
    options: PropTypes.array.isRequired,
    argument: PropTypes.string.isRequired,
    icon: PropTypes.string
}

export default onClickOutside(Overflow);


/** WEBPACK FOOTER **
 ** ./src/components/ui/Overflow.js
 **/